module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-realData",
    class: {
      'pc-realData': !_vm.isMobile
    }
  }, [_c('div', {
    staticClass: "realData"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          实时数据\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "state",
    class: {
      'state-off': _vm.deviceInfo.device_status !== '在线'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "device-statue"
  }, [_vm._v("\n          " + _vm._s(_vm.deviceInfo.device_status) + "\n        ")]), _vm._v(" "), (_vm.realData.alarm) ? [_c('div', {
    staticClass: "state state-error"
  }), _vm._v(" "), _c('div', {
    staticClass: "device-statue",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.realData.alarm) + "\n          ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [_c('div', {
    staticClass: "charts-input"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading.realData
    },
    on: {
      "click": function($event) {
        _vm.loadFreashData()
      }
    }
  }, [_vm._v("刷新数据")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [_c('div', {
    staticClass: "his-data"
  }, [_c('el-button', {
    on: {
      "click": _vm.toogleDrop
    }
  }, [_vm._v(_vm._s(_vm.dropList.show ? '关闭' : '展开历史数据列表'))]), _vm._v(" "), _c('div', {
    staticClass: "data-time"
  }, [_vm._v("\n          " + _vm._s(_vm.tableData.time_stamp) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "drop-list"
  }, [_c('dropList', {
    attrs: {
      "show": _vm.dropList.show,
      "data": _vm.hisDataList,
      "type": "ALLOCATE"
    },
    on: {
      "selectItem": _vm.selectItem,
      "selectDate": _vm.selectDate
    }
  })], 1)]), _vm._v(" "), _c('WxLoading', {
    attrs: {
      "show": _vm.loading.auto
    }
  }), _vm._v(" "), (_vm.loading.realData) ? _c('div', {
    staticClass: "vfor-list"
  }, [_c('el-card', {
    staticClass: "box-card vfor-card no-padding"
  }, [_c('loading')], 1)], 1) : _c('div', {
    staticClass: "m-card"
  }, [_c('div', {
    staticClass: "card-body water-table"
  }, [_c('div', [_c('table', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "setting-th"
  }, [_c('span', [_vm._v("设定值")]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? _c('div', [(_vm.edit.type === 'CLOSE') ? _c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "size": _vm.isMobile ? 'mini' : 'small'
    },
    on: {
      "click": _vm.openEdit
    }
  }, [_vm._v("编辑\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.edit.type === 'OPEN') ? _c('el-button', {
    attrs: {
      "loading": _vm.loading.confData,
      "type": "success",
      "size": _vm.isMobile ? 'mini' : 'small'
    },
    on: {
      "click": _vm.saveConf
    }
  }, [_vm._v(_vm._s(_vm.loading.confData ? '正在通信' : '保存') + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.edit.type === 'OPEN') ? _c('el-button', {
    attrs: {
      "type": "text",
      "size": _vm.isMobile ? 'mini' : 'small'
    },
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v("取消\n                    ")]) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? [_c('tr', [_c('td', [_vm._v("原料/煤料")]), _vm._v(" "), (_vm.loading.confData) ? _c('td', [_vm._v("正在通信")]) : (_vm.edit.type === 'CLOSE') ? _c('td', [_vm._v(_vm._s(_vm.confData['煤料设定标准份数']))]) : _c('td', [_c('el-input', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.confData['煤料设定标准份数']),
      callback: function($$v) {
        var $$exp = _vm.confData,
          $$idx = '煤料设定标准份数';
        if (!Array.isArray($$exp)) {
          _vm.confData['煤料设定标准份数'] = _vm._n($$v)
        } else {
          $$exp.splice($$idx, 1, _vm._n($$v))
        }
      },
      expression: "confData['煤料设定标准份数']"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("--")]), _vm._v(" "), _c('td', [_vm._v("--")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("--")]), _vm._v(" "), _c('td', [_vm._v("--")])])] : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? [_vm._l((_vm.tableData.sdz), function(item) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])])]
  })] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("运行状态")])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? [_c('tr', [_c('td', [_vm._v("原料带")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.yxzt['原料带']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("煤皮秤")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.yxzt['煤皮秤']))])])] : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? [_vm._l((_vm.tableData.yxzt), function(value, key) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value))])])]
  })] : _vm._e()], 2)]), _vm._v(" "), _c('div', [_c('table', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("实时值")])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? [_c('tr', [_c('td', [_vm._v("原料Kg/s")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fAi['原料流量Kg/s']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("煤料Kg/s")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fAi['煤料流量Kg/s']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("原料/煤料")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fhb['原煤时累计比']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("煤秤电机Hz")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fAi['煤料电机Hz']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("煤秤Kg")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fmc['煤秤重量KG']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("  ")]), _vm._v(" "), _c('td')])] : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? [_vm._l((_vm.tableData.fAi), function(item) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])])]
  })] : _vm._e()], 2)]), _vm._v(" "), _c('div', [_c('table', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("时累计")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("原料T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fHour['原料时累计T']))])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? _c('tr', [_c('td', [_vm._v("煤料T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fHour['煤料时累计T']))])]) : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? _c('tr', [_c('td', [_vm._v("加水比例%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fhb['加水时比例%']))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("日累计")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("原料T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fDay['原料日累计T']))])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? [_c('tr', [_c('td', [_vm._v("煤料T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fDay['煤料日累计T']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("原料/煤料%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fdb['原煤日累计比']))])])] : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? [_c('tr', [_c('td', [_vm._v("加水比例%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fdb['加水日比例%']))])])] : _vm._e()], 2)])])])], 1), _vm._v(" "), (_vm.isMobile) ? _c('Mconfirm', {
    attrs: {
      "loading": _vm.loading.confData,
      "show": _vm.edit.type === 'OPEN'
    },
    on: {
      "define": _vm.saveConf,
      "cancel": _vm.closeEdit
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c8fc1f9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/allocateWater/realData.vue
// module id = 904
// module chunks = 1